import { takeLatest, put, call, fork, takeEvery } from 'redux-saga/effects';
import { putLegend, requestLegend } from '../requesters/legendRequester';
import {
  editLegendFailure,
  LegendAction,
  receiveEditLegend,
  receiveLegend,
} from '../actions/legendActions';

/**
 * Get Legend API call
 * @param {action} action
 * @return {void}
 */
export function* getLegend(action) {
  try {
    const { username, fieldUuid, dates, crop, layer, season, subLayer, userUuid } =
      action;
    const response = yield call(
      requestLegend,
      username,
      fieldUuid,
      dates,
      crop,
      layer,
      season,
      userUuid
    );
    return yield put(receiveLegend(response, layer, season, subLayer));
  } catch (error) {
    return null;
  }
}

/**
 * Waits for the return of the LegendAction.RequestLegend action event and
 * calls the getLegend saga
 * @return {void}
 */
export function* getLegendWatcher() {
  yield takeEvery(LegendAction.RequestLegend, getLegend);
}

/**
 * Edit Legend API call
 * @param {action} action
 * @return {void}
 */
export function* editLegend(action) {
  try {
    const { username, fieldUuid, crop, layer, legendValues } = action;
    const response = yield call(
      putLegend,
      username,
      fieldUuid,
      crop,
      layer,
      legendValues
    );
    yield put(receiveEditLegend(response));
    yield call(getLegend, action);
  } catch (error) {
    yield put(editLegendFailure());

  }
}

/**
 * Waits for the return of the LegendAction.EditLegend action event and calls the editLegend saga
 * @return {void}
 */
export function* editLegendWatcher() {
  yield takeLatest(LegendAction.EditLegend, editLegend);
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(getLegendWatcher);
  yield fork(editLegendWatcher);
}
